import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ICourseTutor } from '.';

export type TDeleteCourseTutor = {
  id: string;
};

const apiDataProvider = new APIDataProvider();

export const getCourseTutorsByTutor = createAsyncThunk(
  '/course-tutors/getCourseTutorsByTutor',
  async (tutorId: string) => {
    const path = `${ApiPaths.courseTutors}/${tutorId}`;

    const response = await apiDataProvider.get<
      TApiResponse<Array<ICourseTutor>>
    >(path);

    return response.data;
  }
);
